<h1 mat-dialog-title>{{fullName ? ('users.management.EditUser' | translate:fullName) : ('users.management.NewUser' | translate)}}</h1>
<div mat-dialog-content>
    <user-editor [user]="data.user" [roles]="data.roles" [isEditMode]="true"></user-editor>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="editUser.save();" color="primary">{{'commands.Save' | translate }}</button>
    <button mat-raised-button (click)="cancel()" color="warn">{{'commands.Cancel' | translate }}</button>
</div>
